import { images } from '.';
 
const monthlyRental = [  
    {   
        id: 1, 
        image: images.rtmartNeihu, 
        title: '大潤發內湖店',
        content: '聯絡電話：0935-991-909',
        paragraphs: [
            '地址：台北市內湖區舊宗路1段188號',
            '月租聯絡電話：0935-991-909',
        ]
    },
    {   
        id: 2, 
        image: images.rtmartBitang, 
        title: '大潤發碧潭店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    
    {   
        id: 3, 
        image: images.rtmartGinping, 
        title: '大潤發景平店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市中和區景平路182號B2',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 4, 
        image: images.rtmartTuchen, 
        title: '大潤發土城店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 5, 
        image: images.rtmartChungShiao, 
        title: '大潤發忠孝店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 6, 
        image: images.rtmartChungLi, 
        title: '大潤發中壢店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 7, 
        image: images.rtmartTouFen, 
        title: '大潤發頭份店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 8, 
        image: images.rtmartNayai, 
        title: '大潤發湳雅店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 9, 
        image: images.rtmartBade, 
        title: '大潤發八德店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 10, 
        image: images.rtmartChungmin, 
        title: '大潤發忠明店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 11, 
        image: images.rtmartChaiyi, 
        title: '大潤發嘉義店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 12, 
        image: images.rtmartYuanLin, 
        title: '大潤發員林店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 13, 
        image: images.rtmartTainan, 
        title: '大潤發台南店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 14, 
        image: images.rtmartFonsang, 
        title: '大潤發鳳山店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
 
];

export default monthlyRental;